<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID1038 Body Part -->
							<template>
								<el-container class="SID1038__ResultByuserId">
									<div class="SID1038__Container">
									<!-- Breadcrumb section -->
									<el-breadcrumb separator-class="el-icon-arrow-right">
										<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧) </el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '1035' }"> 原文利用実績照会設定</el-breadcrumb-item>
										<!-- 2021/02/05 #10500 START -->
										<!-- <el-breadcrumb-item :to="{ path: '' }">照会結果ユーザーID別期間</el-breadcrumb-item> -->
										<el-breadcrumb-item :to="{ path: '' }">照会結果（ユーザーID別期間）</el-breadcrumb-item>
										<!-- 2021/02/05 #10500 END -->
										<!-- <el-breadcrumb-item :to="{ path: '' }">照会結果</el-breadcrumb-item> -->
									</el-breadcrumb>
									<div>
										<span class="Inquiry__condition">照会条件</span>
									</div>
									<div>
										<el-divider class="result-main-divider"></el-divider>
									</div>
										<el-container>
											<div class="resultDiv">
												<el-form ref="form" :model="form" class="div-result" label-width="auto">
													<el-form-item label="集計対象 ">
														<span>{{ "ユーザーID別" }}</span>
													</el-form-item>
													<el-form-item label="集計方法 ">
														<span>{{ getFormMethod }}</span>
													</el-form-item>
													<el-form-item label="集計期間 ">
														<span>{{ getPeriodResult1038 }}</span>
													</el-form-item>
													<el-form-item label="集計条件 " >
														<span>{{ returnUserName }}</span>
													</el-form-item>
													
												</el-form>
											</div>
										</el-container>

										<el-container>
										<el-table
										:data="getInquiryPeriodUserResult1038"
										:span-method="arraySpanMethod"
										border
										style="width: 100%"
										class="table-result">
												<el-table-column
													prop="user_group_name"
													label="ユーザーグループＩＤ"
													min-width="190"
												></el-table-column>
												<el-table-column
													prop="user_id"
													label="ユーザーＩＤ"
													min-width="130"
												></el-table-column>
												<el-table-column label="ELNET">
													<el-table-column label="原文">
														<el-table-column
															prop="pdf_count"
															label="表示"
															min-width="auto"
														></el-table-column>
														<el-table-column
															prop="print_count"
															label="印刷"
															min-width="auto"
														></el-table-column>
													</el-table-column>
													<el-table-column label="テキスト本文">
														<el-table-column
															prop="text_disp_count"
															label="表示"
															min-width="auto"
														></el-table-column>
														<el-table-column
															prop="text_print_count"
															label="印刷"
															min-width="auto"
														></el-table-column>
													</el-table-column>
													<el-table-column
														prop="mc_count"
														label="小計"
														min-width="auto"
													></el-table-column>
													<el-table-column
														prop="use_max_count"
														label="月間上限値 （小計が対象）"
														min-width="120"
													></el-table-column>
												</el-table-column>
												<el-table-column label="日経">
													<el-table-column
														prop="sc_text_count"
														label="テキスト"
														min-width="auto"
													></el-table-column>
													<el-table-column
														prop="sc_count"
														label="原文"
														min-width="auto"
													></el-table-column>
													<el-table-column
														prop="sc_use_max_count"
														label="月間上限値 （原文が対象）"
														min-width="120"
													></el-table-column>
												</el-table-column>
												<el-table-column
													label="合計"
													prop="count"
													min-width="auto"
												></el-table-column>
											</el-table>
										</el-container>
										<el-row class="ButtonDiv">
											<el-button type="primary" @click="csvdownload()" plain >CSV出力</el-button>
											<el-button type="info" @click="gotoback" plain>戻る</el-button>
										</el-row>
									</div>
								</el-container>
							</template>
              <!--SID1038 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import json from '../../components/config.json';
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		return {
			form: {},
			returnUserName:""
		};
	},
	methods: {
		//for merging the table coloum as per the req
		arraySpanMethod({ rowIndex, columnIndex }) {
			if (rowIndex === this.getRowCount -1) {
				if (columnIndex === 0) {
					return [1, 2];
				} else if (columnIndex === 1) {
					return [0, 0];
				}
			}
		},
		gotoback()
		{
this.$LogButtonEvent("1038","Return");
this.$LogMethodIN("1038","gotoback");
			router.push({name:"1035"});
			this.$LogMethodOut("1038","gotoback");
		},
		csvdownload(){
this.$LogButtonEvent("1038","CsvOutput");
this.$LogMethodIN("1038","csvdownload");
			this.$confirm(json["1038_CSV_download_message"], json["1038_CSV_download_title"], {
				showCancelButton: true,		
				confirmButtonText: 'OK',
				cancelButtonText: 'キャンセル',
				customClass:'increase-width',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {              										      			
						done();   
						this.$store.dispatch('communication1038/downloadGroupInquiryList',this.$route.params.csvParams)
						.then(() => {
							//After the Ajax call finished check if status is error for showing alert
							var status = this.getCsvDownloadErrStatus;
							var msgdetail = this.getCsvDownloadErrmsgDetail;
							if(status == "1")
							{
								this.$alert(msgdetail,"更新", {	confirmButtonText: 'OK',})
							}
							else
							{
								//console.log("else");
							}
						});
					} 
					else 
					{				
						done();
					}
				}
			});
			this.$LogMethodOut("1038","csvdownload");
		}
	},
	computed: {
		...mapGetters("situation1038", [
			"getTableResult",
			"getFormCount",
			"getFormMethod",
			"getFormPeriod",
			"getFormTitle",
			"getInquiryPeriodUserResult1038",
			"getPeriodResult1038",
			"getRowCount",
			"getCsvDownloadErrStatus",
			"getCsvDownloadErrmsgDetail"
		])
	},
	mounted(){
		
		//Get the Selected UserName 
		var displayUserName=this.$route.params.userIdList.user_name;

		this.returnUserName=displayUserName.join(' ');

		
	},
	created() {
			//For the screen Title
     document.title = "照会結果";
   
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
        this.$router.push('sp/0015');
    }
    else{
        this.$router.push('/1038');
    }

  },
	beforeCreate(){
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
	},
	
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1038.css";
</style>